export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/ob-step-10.png?9db3e4ecb6562148d7b43618a8e64f42";